export { PLATFORM_LIB_INITIALIZER } from "../lib/implementation";
export type { PlatformImpl } from "../lib/impl-types";
export { getSentryInitBase } from "./sentry-init-base";
export {
  getSentryOsPlatformIntegration,
  SentryIntegrationOpts,
} from "./sentry-event-processor";
